/* The three depots. Reference data, not sample data — these are real, they do
   not change, and both the mock and SharePoint providers read them from here
   rather than one importing the other's fixtures.

   Identity only. This used to carry each site's street address, invented when
   the shell was built and then rendered in three places as though somebody had
   checked it — which is the 60%-accurate register §17 warns about, in miniature:
   wrong, and indistinguishable from right. Addresses, phone numbers and access
   notes now live in Blueprint_Locations, where a person can correct them, and
   the field is gone from IDepot so nothing can quietly reintroduce a guess. */

import type { IDepot } from '../models';

export const DEPOTS: IDepot[] = [
  { id: 'Hull', name: 'Hull', sub: 'Head office', short: 'HUL' },
  { id: 'Doncaster', name: 'Doncaster', sub: 'Depot & training centre', short: 'DON' },
  { id: 'London', name: 'London', sub: 'Sales office', short: 'LON' },
];

export function depotName(id: string): string {
  return DEPOTS.find((d) => d.id === id)?.name ?? '—';
}
